import customerRelationshipsService from './customerRelationshipsService'

export default customerRelationshipsService


// WEBPACK FOOTER //
// ../src/services/customerRelationshipsService/index.js